var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"keyboard-input"},_vm._l((13),function(value){return _c('button',{key:value,staticClass:"key",class:{black: _vm.isBlack(value-1), white: !_vm.isBlack(value-1)},style:(_vm.keyStyle[value-1]),on:{"click":function($event){$event.stopPropagation();return _vm.solve(value-1)}}})}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39f78e98","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/KeyboardInput.vue
// module id = null
// module chunks = 